import { useGetCrossbarQuery } from "crossbar/api/crossbar.api";
import { useParams } from "react-router-dom";

import { CrossbarAdminForm } from "crossbar/components/CrossbarAdminForm";

export function CrossbarAdminView({ isCreateMode }: { isCreateMode: boolean }) {
  const { crossbarId } = useParams<{ crossbarId: string }>();
  const { data: crossbar } = useGetCrossbarQuery(crossbarId!);
  return (
    <>
      {crossbar ? (
        <CrossbarAdminForm crossbar={crossbar} editMode={true} />
      ) : null}

      {!crossbarId && !crossbar ? <CrossbarAdminForm editMode={false} /> : null}
    </>
  );
}
